import { FaShapes, FaSpaceShuttle, FaTools } from "react-icons/fa";
import {
  GiComputerFan,
  GiGuitar,
  GiHypersonicBolt,
  GiTechnoHeart,
} from "react-icons/gi";
import { GoLightBulb, GoSquirrel } from "react-icons/go";
import { MdPerson, MdPersonOutline } from "react-icons/md";

import default_repair from "Images/default_repair.png";
import dotenv from "dotenv";

export const defaultIcons = [
  GiComputerFan,
  FaTools,
  GiGuitar,
  GiHypersonicBolt,
  MdPerson,
  MdPersonOutline,
  GiTechnoHeart,
  FaShapes,
  FaSpaceShuttle,
  GoLightBulb,
  GoSquirrel,
];

export const getRandomInt = (max) => {
  return Math.floor(Math.random() * Math.floor(max));
};

const getDefaultIcon = defaultIcons[getRandomInt(defaultIcons.length)];

dotenv.config();

let RunWebsocketConnection = false;

// const SSL = false;

let APIServer = "http://localhost:8000/api/v1/";
let imageRoot = "http://localhost:8000";

// if (SSL) {
//   APIServer = "https://localhost:8000/api/v1/";
//   imageRoot = "https://localhost:8000";
// }

if (process.env.NODE_ENV === "production") {
  APIServer = process.env.REACT_APP_BACKEND;
  imageRoot = process.env.REACT_APP_IMAGE_ROOT;
}

export default {
  AppName: "Tinker",
  APIServer: APIServer,
  NoProfilePic: getDefaultIcon, // default_user,
  NoFixPic: default_repair,
  RunWebsocketConnection: RunWebsocketConnection,
  imageRoot,
};
